(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name commons.service:DateUtilService
   *
   * @description
   *
   */
  angular
    .module('commons')
    .service('DateUtilService', DateUtilService);

  function DateUtilService() {
    var self = this;

    self.getLastDateOfMonth = function (dateString) {
      const parts = dateString.split('/');
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);

      const nextMonth = new Date(year, month, 0);

      var lastDay = nextMonth.getDate();
      var lastMonth = nextMonth.getMonth() + 1;
      var lastYear = nextMonth.getFullYear();

      // Ensure the day and month are 2 digits
      if (lastDay < 10) lastDay = '0' + lastDay;
      if (lastMonth < 10) lastMonth = '0' + lastMonth;

      return lastDay + '/' + lastMonth + '/' + lastYear;
    };

    self.get12MonthsEarlierDate = function (dateString) {
      const parts = dateString.split('/');
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);

      const earlierDate = new Date(year, month-11, 1)

      var newDay = earlierDate.getDate();
      var newMonth = earlierDate.getMonth();
      var newYear = earlierDate.getFullYear();

      // Ensure the day and month are 2 digits
      if (newDay < 10) newDay = '0' + newDay;
      if (newMonth < 10) newMonth = '0' + newMonth;

      return newDay + '/' + newMonth + '/' + newYear;
    }

    self.getYearStartDate = function (dateString) {
      const parts = dateString.split('/');
      const year = parseInt(parts[2], 10);

      return '01/01/' + year;
    }

  }
}());
